// extracted by mini-css-extract-plugin
export default {"root":"EzoSIlDyYKy8Rst9BjCg","menu":"Ielld6RV6xfX5gDM5ehw","actions":"w2S5RuDi_W1P4RajbnJG","discover":"YpbJgfnlfUiy0Lk06y5g"};